var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:this.$route.path.startsWith('/recibo/') ? 'clean' : ''},[_c('router-view'),_c('div',{staticClass:"clearfix"}),_c('notifications',{attrs:{"group":"a"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }